import React from "react";
import { ChevronDown, ChevronRight, Lock } from "lucide-react";
import { AfspraakRow } from "./AfspraakRow";
import { NONE_KEY, INTERN_KEY } from "./afsprakenUtils";

const slug = (key) => (key === NONE_KEY ? "geen-locatie" : key === INTERN_KEY ? "intern" : key);

export const LocatieGroepen = ({ groups, isOpen, onToggle, selectedId, onSelect }) => (
  <div className="space-y-3 md:space-y-4" data-testid="afspraken-lijst">
    {groups.map((g) => {
      const open = isOpen(g);
      return (
        <div key={g.key} data-testid={`afspraken-group-${slug(g.key)}`}>
          <button data-testid={`group-toggle-${slug(g.key)}`} onClick={() => onToggle(g)} aria-expanded={open}
            className={`w-full flex items-center justify-between gap-3 px-3 py-2 bg-zinc-950 text-white hover:bg-zinc-900 transition-colors ${open ? "rounded-t-[10px]" : "rounded-[10px]"}`}>
            <span className="flex items-center gap-2 min-w-0">
              {g.intern && <Lock className="h-4 w-4 text-zinc-300 shrink-0" />}
              <span className="font-heading font-black uppercase tracking-[.06em] text-xs truncate">{g.label}</span>
            </span>
            <span className="flex items-center gap-2 shrink-0 text-[11px] font-mono">
              <span className="text-zinc-400">{g.items.length} open</span>
              {g.telaat > 0 && <span className="text-rose-300">· {g.telaat} te laat</span>}
              {g.dezeweek > 0 && <span className="text-amber-200">· {g.dezeweek} deze week</span>}
              {open ? <ChevronDown className="h-4 w-4 text-zinc-400" /> : <ChevronRight className="h-4 w-4 text-zinc-400" />}
            </span>
          </button>
          {open && (
            <div className="bg-white border border-t-0 border-zinc-200 rounded-b-[10px] divide-y divide-zinc-200">
              {g.intern && <p data-testid="intern-groep-uitleg" className="px-4 py-2 text-xs text-zinc-500 bg-zinc-50">Alleen zichtbaar voor de betrokkenen en oversight</p>}
              {g.items.map((a) => <AfspraakRow key={a.id} a={a} selected={a.id === selectedId} onSelect={onSelect} />)}
            </div>
          )}
        </div>
      );
    })}
  </div>
);
